import Box from "@mui/material/Box";
import { ReactComponent as AddNew } from "assets/AddNew.svg";
import { setActiveActionCard } from "components/app/App.slice";
import AsyncAutocomplete from "components/common/Autocomplete";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Form from "components/common/Form";
import Typography from "components/common/Typography";
import Dropdown from "components/common/dropdowns/DropDown";
import ActionDetailsDialog from "components/features/ActionCardDetails/ActionDetailsDialog";
import { useTranslate } from "hooks/useTranslate";
import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import {
  converter_ArrayObj,
  createParamforSearch,
  getFilteredAssignees,
  getLoggedInUserDetails,
  getUserHltId
} from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import ActionImportDialog from "../ActionCardDetails/ActionImportDialog";
import {
  copyActionAsync,
  createSectionAsync,
  deleteActionCardAsync,
  fetchMyPlanDetailAsync,
  markPlanCompleteAsync,
  setIsRedirectFromNotification
} from "../MyPlanDetails/MyPlanDetails.slice";
import { fetchMyPlansWithInncodesAsync } from "../MyPlans/myplans.slice";
import PlanDetailDialog from "../PlanAssignment/PlanSelection/PlanDetailDialog";
import { setCopySectionData } from "../planDetails/PlanDetail.slice";
import ActionCardHelper from "./ActionCardHelper";
import ActionCardDialogsContext from "./Context";

function Dialogs() {
  const dispatch = useAppDispatch();
  const formRef = React.useRef<any>(null);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const isConsultant = useAppSelector((state) => state.app.loggedInUserDetails.isConsultant);
  const isActionHighlight = useAppSelector((state: any) => state.myplans?.MyPlans.isActionHighlight);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const activeCard: any = useAppSelector((state) => state.app.activeActionCard);
  const myPlansWithInncodes: any = useAppSelector((state) => state.myplans.MyPlansWithInncodes?.list);
  const myPlanDetails: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const allAssigneesData = useAppSelector((state) => state.myPlanDetails.ad);
  const selectedCards: any = useAppSelector((state) => state?.app?.selectedCards);
  const copySectionData = useAppSelector((state) => state.planDetails.copySectionData);
  const translate = useTranslate();
  const [showPreview, setShowPreview] = useState(false);
  const [sectionDisable, setSectionDisable] = useState(true);
  const [targetPlanId, setTargetPlanId] = useState();
  const [targetSectionId, setTargetSectionId] = useState();
  const [assigneeVal, setAssigneeVal] = useState<string[]>([]);
  const [planOptions, setPlanOptions] = useState([]);
  const param = useParams();
  const location = useLocation();
  const [inputValue, setInputValue] = useState<string>("");
  const isMultipleCardsSelected = selectedCards?.cardList.length;
  const planId = activeCard.planId ?? selectedCards.planId;
  const allAssignees = getFilteredAssignees(activeCard.assignee, allAssigneesData);

  const navigate = useNavigate();

  const {
    isOpenAddActionDialog,
    setIsOpenAddActionDialog,
    isOpenDeleteActionDialog,
    setIsOpenDeleteActionDialog,
    isOpenViewActionDialog,
    setIsOpenViewActionDialog,
    isOpenCreatePlan,
    setIsOpenCreatePlan,
    isOpenEditActionDialog,
    setIsOpenEditActionDialog,
    isOpenCopyActionDialog,
    setIsOpenCopyActionDialog,
    isOpenAssigneeDialog,
    setIsOpenAssigneeDialog,
    isOpenImportActionDialog,
    setIsOpenImportActionDialog,
    isOpenPlanDetailDialog
  } = React.useContext(ActionCardDialogsContext);

  useEffect(() => {
    const newOptions = converter_ArrayObj(myPlansWithInncodes, "title");
    setPlanOptions(newOptions);
  }, [myPlansWithInncodes]);

  useEffect(() => {
    if (isOpenCopyActionDialog)
      dispatch(fetchMyPlansWithInncodesAsync({ innCode: innCode, size: 100, searchedHltId: getUserHltId() }));
    setTargetPlanId(undefined);
  }, [isOpenCopyActionDialog]);

  const handleCopyDialog = () => {
    dispatch(setCopySectionData({}));
    setSectionDisable(true);
    closeCopyDialog();
    setIsOpenCreatePlan(false);
  };

  const closeCopyDialog = () => {
    setIsOpenCopyActionDialog(false);
    setInputValue("");
  };

  const getPlanId = (val: any) => {
    if (val) {
      setIsOpenCopyActionDialog(true);
      setTargetPlanId(val);
      if (!copySectionData?.copySectionType) dispatch(fetchMyPlanDetailAsync({ id: val }));
      setSectionDisable(false);
    }
  };

  const getSectionId = (val: any) => {
    setTargetSectionId(val);
  };

  const createPlanForm = () => {
    closeCopyDialog();
    setIsOpenCreatePlan(true);
  };

  const formSubmit = () => {
    formRef?.current?.submitForm();
  };

  const deleteAction = async () => {
    let props = {};

    if (isMultipleCardsSelected) {
      props = {
        planId: planId,
        sectionId: selectedCards.sectionId,
        cardId: selectedCards?.cardList?.map((el: any) => el.id),
        cardEditable: selectedCards?.cardList?.find((el: any) => el.cardEditable === "N")
      };
    } else {
      props = {
        planId: planId,
        sectionId: activeCard.sectionId,
        cardId: [activeCard.id]
      };
    }

    const response = await dispatch(deleteActionCardAsync(props));
    if (response?.payload?.status === responseTypes?.success || response?.payload?.status === responseTypes?.deleted) {
      await dispatch(fetchMyPlanDetailAsync({ id: planId, includePropertyInfo: true }));
    }
    setIsOpenDeleteActionDialog(false);
  };

  const assignActionCard = async () => {
    let cardsPayload: any = [];
    if (isMultipleCardsSelected) {
      const cardsList = [...selectedCards.cardList];
      let cardsListAssignee;
      if (assigneeVal) {
        let assignees: string[];
        cardsListAssignee = cardsList.map((el: any) => {
          assignees = el.assignee ? Array.from(new Set([...(el?.assignee || []), ...assigneeVal])) : assigneeVal;
          return { id: el?.id, assignee: assignees };
        });
      }
      cardsPayload = cardsListAssignee;
    } else
      cardsPayload = [
        {
          id: activeCard?.id,
          assignee: assigneeVal
        }
      ];

    const res = await dispatch(
      markPlanCompleteAsync({
        planId: planId,
        type: "bulk_assign",
        isActionHighlight,
        payload: {
          updateType: "UPDATE_ASSIGNEE",
          sections: [
            {
              id: selectedCards.sectionId || activeCard?.sectionId,
              cardModels: cardsPayload
            }
          ]
        }
      })
    );
    if (res?.meta?.requestStatus === "fulfilled") setIsOpenAssigneeDialog(false);
  };

  const copyToExistingPlan = async () => {
    let response;
    if (copySectionData?.copySectionType) {
      const props = {
        planId: targetPlanId,
        ...copySectionData.sectionPayload[0]
      };
      response = await dispatch(createSectionAsync(props));
    } else if (isMultipleCardsSelected) {
      const payload = { cards: selectedCards?.cardList };
      const url = { planId: targetPlanId, sectionId: targetSectionId };
      dispatch(copyActionAsync({ url, payload }));
    } else {
      const cards = [];
      cards.push(activeCard);
      const payload = { cards: cards };
      const url = { planId: targetPlanId, sectionId: targetSectionId };
      dispatch(copyActionAsync({ url, payload }));
    }
    const sectionId = copySectionData?.copySectionType
      ? response?.payload?.sections[response?.payload?.sections?.length - 1]?.id
      : targetSectionId;
    navigate(`/myplandetails/${targetPlanId}/${sectionId}`);
    closeCopyDialog();
    dispatch(setCopySectionData({}));
    setIsOpenViewActionDialog(false);
  };

  const handleInputChange = (val: string) => {
    setInputValue(val);
  };

  useEffect(() => {
    const clonedFiltredSearch = converter_ArrayObj(myPlansWithInncodes, "title");
    const searchTerm = inputValue?.toLowerCase();
    const filtredSearch = clonedFiltredSearch.filter((item: any) => item?.val?.toLowerCase().includes(searchTerm));
    setPlanOptions(filtredSearch);
  }, [inputValue]);

  const redirectToSecId = () => {
    const id = param.id;
    const cardId = param.cardId;
    const segments = location?.pathname?.split("/");
    const path = segments[1];
    if (cardId) navigate(`/${path}/${id}`, { replace: true });
  };

  const showDialog = showPreview ? (
    <ActionDetailsDialog
      open={showPreview}
      isPreview={true}
      setShowPreview={setShowPreview}
      handleClose={() => setIsOpenAddActionDialog(false)}
    />
  ) : (
    <ActionImportDialog
      setShowPreview={setShowPreview}
      open={isOpenImportActionDialog}
      handleClose={() => setIsOpenImportActionDialog(false)}
    />
  );
  return (
    <>
      <ActionCardHelper />
      {isOpenImportActionDialog || showPreview ? showDialog : <></>}
      {(isOpenViewActionDialog || isOpenEditActionDialog) && (
        <ActionDetailsDialog
          isEdit={isOpenEditActionDialog}
          open={isOpenViewActionDialog || isOpenEditActionDialog}
          setOpen={() => setIsOpenViewActionDialog(true)}
          handleClose={() => {
            dispatch(setActiveActionCard({}));
            dispatch(setIsRedirectFromNotification(false));
            setIsOpenEditActionDialog(false);
            setIsOpenViewActionDialog(false);
            redirectToSecId();
          }}
          assigneeList={allAssignees}
        />
      )}

      {isOpenAddActionDialog && (
        <ActionDetailsDialog
          open={isOpenAddActionDialog}
          isNew={true}
          handleClose={() => setIsOpenAddActionDialog(false)}
          assigneeList={[getLoggedInUserDetails()]}
        />
      )}

      {isOpenCopyActionDialog && (
        <DialogFormation
          title={copySectionData?.dialogTitle || translate("library.copyActionToMyPlan.popup.title")}
          openDialog={isOpenCopyActionDialog}
          handleClose={handleCopyDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCopyDialog} />
              <Button
                accessType={accessTypes.update}
                variant="primary"
                label="Confirm"
                disabled={copySectionData?.copySectionType ? !targetPlanId : !targetSectionId}
                onClick={copyToExistingPlan}
              />
            </div>
          }
        >
          <div className="vertical-center display-col">
            <Box width="60%">
              <Dropdown
                handleChangeUpdate={(val) => getPlanId(val)}
                options={planOptions}
                selectStatement="Select a plan"
                sx={{ minWidth: "80%" }}
                isInputEnabled={true}
                inputValue={inputValue}
                handleInputChange={handleInputChange}
              />
              {!copySectionData?.copySectionType && (
                <Dropdown
                  handleChangeUpdate={(val: any) => getSectionId(val)}
                  disabled={sectionDisable}
                  options={converter_ArrayObj(myPlanDetails?.sections, "name")}
                  selectStatement="Select a section"
                  sx={{ minWidth: "80%" }}
                />
              )}
              {copySectionData?.copySectionType && (
                <Typography
                  className="text-center"
                  sx={{ marginBottom: "8px" }}
                  variant={"body2"}
                  children={"or"}
                ></Typography>
              )}
              {!isCorp && !isConsultant && (
                <Button
                  accessType={accessTypes.update}
                  label={translate("library.copyActionToMyPlan.popup.createPlanButtonLabel")}
                  width="100%"
                  variant="secondary"
                  startIcon={<AddNew />}
                  onClick={createPlanForm}
                  sx={{ borderRadius: "8px", border: `1px solid ${tokens.Border.General.Tertiary}` }}
                />
              )}
            </Box>
          </div>
        </DialogFormation>
      )}

      {isOpenCreatePlan && (
        <DialogFormation
          title="Create new plan"
          openDialog={isOpenCreatePlan}
          handleClose={handleCopyDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCopyDialog} />
              <Button variant="primary" label="Save" onClick={formSubmit} />
            </div>
          }
        >
          <div className="modal-config-wrapper">
            <Form
              ref={formRef}
              item={isMultipleCardsSelected ? selectedCards?.cardList : [activeCard]}
              sectionPayload={copySectionData?.sectionPayload}
              handleCloseDialog={handleCopyDialog}
            />
          </div>
        </DialogFormation>
      )}

      {isOpenAssigneeDialog && (
        <DialogFormation
          openDialog={isOpenAssigneeDialog}
          handleClose={() => {
            dispatch(setActiveActionCard({}));
            setIsOpenAssigneeDialog(false);
          }}
          subHeading="Action Assignment"
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                onClick={() => {
                  setIsOpenAssigneeDialog(false);
                  dispatch(setActiveActionCard({}));
                }}
                label="Cancel"
              />
              <Button variant="primary" label="Save" onClick={assignActionCard} />
            </div>
          }
        >
          <Box width={"100%"} justifyContent="center">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} textAlign="left">
              Assign to
            </Typography>
            <AsyncAutocomplete
              assigneeList={allAssignees}
              getUserDetail={(val) => setAssigneeVal(val)}
              placeholder="Search a user"
              searchParams={{ innCode: createParamforSearch(isCorp, myPlanDetails?.innCode) }}
            />
          </Box>
        </DialogFormation>
      )}

      {isOpenDeleteActionDialog && (
        <DialogFormation
          title="Delete Action"
          openDialog={isOpenDeleteActionDialog}
          handleClose={() => {
            dispatch(setActiveActionCard({}));
            setIsOpenDeleteActionDialog(false);
          }}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={() => setIsOpenDeleteActionDialog(false)} />
              <Button label="Proceed" onClick={deleteAction} />
            </div>
          }
        >
          <div className="vertical-center display-col">
            This will permanently delete the Action.
            <Box>Do you wish to proceed?</Box>
          </div>
        </DialogFormation>
      )}

      {isOpenPlanDetailDialog && <PlanDetailDialog />}
    </>
  );
}

export default Dialogs;
